<template>
  <div id="app" style="width: 100%; padding: 10px; box-sizing: border-box;">
    <el-card title="停车放行验证" style="max-width: 100%;">
      <div class="title-container">
        <img src="./assets/logo.png" alt="">
        <div class="title">笑傲将胡停车验证系统</div>
      </div>
      <div style="margin-bottom: 15px; font-size: 14px; color: #333;">请输入车牌号：</div>
      
      <!-- 车牌号输入区域 - 核心样式修改 -->
      <div class="plate-input-container">
        <!-- 车牌号格子 + 分隔符布局 -->
        <div class="plate-input-wrapper">
          <!-- 省份格子（黄色背景） -->
          <div
            class="plate-input-item"
            :class="{ active: currentInputIndex === 0 }"
            @click="focusInput(0)"
          >
            {{ plateChars[0] || '' }}
          </div>
          
          <!-- 第2格 + 分隔符 · -->
          <div
            class="plate-input-item normal-item"
            :class="{ active: currentInputIndex === 1 }"
            @click="focusInput(1)"
          >
            {{ plateChars[1] || '' }}
          </div>
          <span class="plate-separator">·</span>
          
          <!-- 第3到倒数第2格 -->
          <div
            v-for="(item, index) in plateLength - 2"
            :key="index + 2"
            class="plate-input-item normal-item"
            :class="{ active: currentInputIndex === index + 2 }"
            @click="focusInput(index + 2)"
          >
            {{ plateChars[index + 2] || '' }}
          </div>
          
          <!-- 新能源按钮（替代switch） -->
          <div 
            class="new-energy-btn" 
            @click="toggleNewEnergy"
            :class="{ active: isNewEnergy }"
          >
            {{ isNewEnergy ? '燃油车' : '+新能源' }}
          </div>
        </div>
        
        <!-- 操作按钮 -->
        <div style="margin-top: 10px;">
          <el-button size="normal" type="text" @click="deleteChar">删除</el-button>
          <el-button size="normal" type="text" @click="clearAll">清空</el-button>
        </div>
      </div>

      <!-- 订单截图上传 -->
      <!-- <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="订单截图" prop="orderImage">
          <el-upload
            ref="upload"
            :auto-upload="false"
            :file-list="fileList"
            :on-change="handleFileChange"
            accept="image/*"
            action="#"
            :limit="1"
          >
            <el-button size="small" type="primary">点击上传截图</el-button>
            <div slot="tip" class="el-upload__tip">仅支持jpg/png格式，大小不超过2MB</div>
          </el-upload>
        </el-form-item>
      </el-form> -->
      <!-- 历史输入车牌，保留最近10个，存放在localstorage -->
      <div class="his-plate">
        <el-tag class="plate-tag" v-for="(item, index) in historyPlates" :key="index" closable @close="removeHistoryPlate(index)">
          <span @click="selectPlate(item)">{{ item }}</span>
        </el-tag>
      </div>
      <!-- 订单号输入框 -->
       <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="订单号" prop="orderNumber">
          <el-input v-model="form.orderNumber" placeholder="请输入订单号" @focus="showKeyboard = false"></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 15px; font-size: 14px; color: red; white-space: pre-wrap;">
        {{ `提示：\n  1.注意时效。免费停车仅限包间预约时段以及结束后1小时内，逾期无法申请。\n  2.及时离场。申请成功后，请于15分钟内离场，超时将无法免费。\n  3.如有问题请联系商家。` }}
      </div>
      <!-- 提交按钮 -->
      <div class="op-button-container">
        <el-button type="primary" @click="submitForm" >提交验证</el-button>
        <el-button @click="resetForm" >重置</el-button>
      </div>
    </el-card>

    <!-- 结果提示弹窗 -->
    <el-dialog
      title="验证结果"
      :visible.sync="resultVisible"
      width="80%"
      :close-on-click-modal="false"
    >
      <span>{{ resultMsg }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resultVisible = false">确定</el-button>
      </span>
    </el-dialog>

    <!-- 移动端虚拟键盘（样式优化） -->
    <div class="keyboard" v-if="showKeyboard">
      <div class="keybord-op">
        <div @click="toggleKeyboard">收起</div>
      </div>
      <div v-for="(row, rowIndex) in currentKeyboardRows" :key="rowIndex" class="keyboard-row">
        <button
          v-for="(key, keyIndex) in row"
          :key="keyIndex"
          class="keyboard-btn"
          @click="inputKey(key)"
        >
          {{ key }}
        </button>
      </div>
    </div>
    <div class="beian-info">
      <p>©2026 笑傲将胡棋牌馆. All rights reserved.</p>
      <p><a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2026003039号-1</a></p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

export default {
  name: 'App',
  data() {
    return {
      form: {
        plateNumber: '', // 完整车牌号
        orderNumber: '',
        orderImage: null // 上传的图片文件
      },
      fileList: [], // 上传文件列表
      rules: {
        plateNumber: [
          { required: true, message: '请完整输入车牌号', trigger: 'blur' }
        ],
        orderImage: [
          { required: true, message: '请上传订单截图', trigger: 'change' }
        ],
        orderNumber: [
          { required: true, message: '请输入订单号', trigger: 'blur' }
        ]
      },
      resultVisible: false, // 结果弹窗是否显示
      resultMsg: '', // 结果提示语
      showKeyboard: false, // 虚拟键盘显示状态
      isNewEnergy: false, // 是否新能源车牌（8位）
      plateLength: 7, // 车牌号长度（默认7位，新能源8位）
      plateChars: [], // 存储每个格子的字符
      currentInputIndex: 2, // 当前激活的输入格子索引

      // 键盘配置 - 匹配图片中的省份键盘
      keyboardConfig: {
        // 第1格：省份简称 + 特殊前缀（完全匹配图片）
        first: [
          ['京', '沪', '粤', '津', '冀', '晋', '蒙', '辽', '吉', '黑'],
          ['苏', '浙', '皖', '闽', '赣', '鲁', '豫', '鄂', '湘', '军'],
          ['桂', '琼', '渝', '川', '贵', '云', '藏', '陕', '兰', '济'],
          ['甘', '青', '宁', '新', '使', '警', '电', '无', '深', '临']
        ],
        // 第2格：市州字母
        second: [
          ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
          ['J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R'],
          ['S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        ],
        // 3+格：数字/字母/特殊字符
        other: [
          ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
          ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
          ['K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T'],
          ['U', 'V', 'W', 'X', 'Y', 'Z', '港', '澳', '学', '警']
        ]
      },
      historyPlates: []
    }
  },
  computed: {
    // 根据当前激活的格子显示对应键盘
    currentKeyboardRows() {
      if (this.currentInputIndex === 0) {
        return this.keyboardConfig.first
      } else if (this.currentInputIndex === 1) {
        return this.keyboardConfig.second
      } else {
        return this.keyboardConfig.other
      }
    }
  },
  created() {
    // 初始化车牌号格子（空数组）
    this.plateChars = Array(this.plateLength).fill('')
    this.plateChars[0] = '川'
    this.plateChars[1] = 'X'
    // 初始化历史车牌
    this.historyPlates = JSON.parse(localStorage.getItem('historyPlates')) || []
  },
  methods: {
    selectPlate(plate) {
      // 使用车牌号填充车牌号格子，如果是新能源，显示新能源格子并填充
      if (plate.length === 8) {
        this.isNewEnergy = true
        this.plateLength = 8
        this.plateChars = plate.split('')
      } else {
        this.isNewEnergy = false
        this.plateLength = 7
        this.plateChars = plate.split('')
      }
      this.form.plateNumber = plate
      this.currentInputIndex = this.plateLength - 1
      this.showKeyboard = false
    },
    removeHistoryPlate(index) {
      this.historyPlates.splice(index, 1)
      localStorage.setItem('historyPlates', JSON.stringify(this.historyPlates))
    },
    toggleKeyboard() {
      this.showKeyboard = !this.showKeyboard
    }, 
    // 切换新能源车牌（替代switch的change事件）
    toggleNewEnergy() {
      this.isNewEnergy = !this.isNewEnergy
      if (this.isNewEnergy && this.currentInputIndex === this.plateLength - 1) {
        this.currentInputIndex += 1
      }
      this.resetPlateChars()
    },
    // 重置车牌号格子（核心逻辑保留，适配新样式）
    resetPlateChars() {
      const oldLength = this.plateLength 
      this.plateLength = this.isNewEnergy ? 8 : 7 
      const newPlateChars = [...this.plateChars] 

      if (this.plateLength > oldLength) {
        newPlateChars.push('')
      } else if (this.plateLength < oldLength) {
        newPlateChars.splice(this.plateLength) 
      }

      while (newPlateChars.length < this.plateLength) {
        newPlateChars.push('')
      }

      this.plateChars = newPlateChars
      if (this.currentInputIndex >= this.plateLength) {
        this.currentInputIndex = this.plateLength - 1
      }
      this.form.plateNumber = this.plateChars.join('')
    },
    // 激活指定输入格子
    focusInput(index) {
      this.showKeyboard = true
      this.currentInputIndex = index
    },
    // 键盘输入字符
    inputKey(key) {
      if (this.currentInputIndex < this.plateLength) {
        this.plateChars.splice(this.currentInputIndex, 1, key)
        if (this.currentInputIndex < this.plateLength - 1) {
          this.currentInputIndex += 1
        } else {
          // 隐藏键盘
          this.showKeyboard = false
        }
        this.form.plateNumber = this.plateChars.join('')
      }
    },
    // 删除当前字符
    deleteChar() {
      if (this.currentInputIndex >= 0) {
        this.plateChars.splice(this.currentInputIndex, 1, '')
        if (this.currentInputIndex > 0) {
          this.currentInputIndex -= 1
        }
        this.form.plateNumber = this.plateChars.join('')
      }
    },
    // 清空所有字符
    clearAll() {
      this.plateChars = Array(this.plateLength).fill('')
      this.currentInputIndex = 0
      this.form.plateNumber = ''
    },
    // 监听文件上传变化
    handleFileChange(file) {
      this.form.orderImage = file.raw 
      this.fileList = [file] 
    },
    // 提交表单
    async submitForm() {
      this.showKeyboard = false
      const isValid = await this.$refs.form.validate()
      console.log('isValid', isValid)
      if (!isValid) return

      const isPlateComplete = this.plateChars.every(char => char !== '')
      if (!isPlateComplete) {
        this.$message.warning('请完整输入车牌号')
        return
      }
      if (!this.form.orderNumber) {
        this.$message.warning('请输入订单号')
        return
      }
      // 校验订单号为纯数字
      if (!this.form.orderNumber.match(/^\d+$/)) {
        this.$message.warning('订单号为纯数字')
        return
      }

      const formData = new FormData()
      formData.append('plate_number', this.form.plateNumber)
      formData.append('order_id', this.form.orderNumber)
      // formData.append('order_image', this.form.orderImage)
      console.log(formData)

      const res = await axios({
        url: 'https://lsxajh.cn:8008/api/parking/verify-by-order', 
        // url: 'http://localhost:8008/api/parking/verify-by-order', 
        method: 'POST',
        data: formData,
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data' 
        }
      })

      this.resultVisible = true
      this.resultMsg = res.data.msg
      if (res.data.code === 200) {
        // 添加到历史, 去重
        if (!this.historyPlates.includes(this.form.plateNumber)) {
          this.historyPlates.unshift(this.form.plateNumber)
          this.historyPlates = this.historyPlates.slice(0, 10)
          localStorage.setItem('historyPlates', JSON.stringify(this.historyPlates))
        }
      }
    },
    // 重置表单
    resetForm() {
      this.$refs.form.resetFields()
      this.fileList = []
      this.form.orderImage = null
      this.plateChars = Array(this.plateLength).fill('')
      this.currentInputIndex = 0
      this.form.plateNumber = ''
    }
  }
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.title-container {
  text-align: center;
  img {
    width: 100px;
    height: 100px;
  }
  .title {
    font-size: 28px;
    margin: 10px 0px 20px 0px;
    font-weight: bold;
  }
}
/* 车牌号输入容器样式 */
.plate-input-container {
  margin-bottom: 10px;
}

/* 车牌号输入格子外层布局 */
.plate-input-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
}

/* 普通输入格子样式 */
.normal-item {
  background-color: #fff;
}

/* 输入格子通用样式 */
.plate-input-item {
  width: 30px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 18px;
  margin: 0 1px;
  cursor: pointer;
  flex-shrink: 0;
}

/* 激活状态 */
.plate-input-item.active {
  border-color: #409eff;
  box-shadow: 0 0 5px rgba(64, 158, 255, 0.5);
}

/* 分隔符 · 样式 */
.plate-separator {
  margin: 0 2px;
  font-size: 18px;
  color: #666;
}

/* 新能源按钮样式 */
.new-energy-btn {
  width: 60px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border: 1px solid #4cd964;
  border-radius: 4px;
  font-size: 14px;
  color: #4cd964;
  margin-left: 5px;
  cursor: pointer;
  flex-shrink: 0;
}

.new-energy-btn.active {
  background-color: #140de6;
  color: #fff;
}

/* 虚拟键盘样式优化（匹配图片） */
.keyboard {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: #f8f8f8;
  padding: 10px;
  border-radius: 8px;
  .keybord-op {
    display: flex;
    justify-content: end;
    margin: 5px 0px;
    color: #409EFF;
  }
}

.keyboard-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.keyboard-btn {
  width: 9%;
  height: 45px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background-color: #fff;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.keyboard-btn:active {
  background-color: #e6f7ff;
  border-color: #91d5ff;
}

.op-button-container {
  display: flex;
  flex-direction: column;
  .el-button {
    margin-top: 10px;
  }
  .el-button+.el-button {
    margin-left: 0px;
  }
}

/* 备案信息样式 */
.beian-info {
  text-align: center;
  padding: 20px 10px;
  /* margin-top: auto; */
  font-size: 14px;
  color: #999;
  /* border-top: 1px solid #eee; */
  /* background-color: #fff; */
}

.beian-info p {
  margin: 5px 0;
}

.beian-info a {
  color: #999;
  text-decoration: none;
}

.beian-info a:hover {
  color: #409eff;
  text-decoration: underline;
}

.his-plate {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  .plate-tag {
    margin: 0px 10px 10px 0px;
  }
}
</style>